<template lang="html">
  <div class="financial-data">
    <div
      v-if="errors"
      v-for="error in errors"
      :key="error.key"
      v-html="error.message"
      class="alert alert-danger text-center"
      role="alert" />
    <div class="card">
      <div class="card-header">
        <h3>Dados Financeiros</h3>
      </div>
      <div class="card-body">
        <form
          ref="financialDataForm"
          class="text-center"
          @submit.prevent="onSubmit"
          @keydown.enter.prevent="onSubmit">
          <div class="form-group row">
            <label
              for="cpfCnpj"
              class="col-sm-4 col-form-label">* CPF ou CNPJ</label>
            <div class="col-sm-8">
              <div class="input-group">
                <span class="input-group-prepend">
                  <label class="input-group-text">{{ cpfCnpjLabel }}</label>
                </span>
                <input
                  id="cpfCnpj"
                  type="text"
                  class="form-control"
                  :style="{ 'color': cpfCnpjValid ? 'green' : 'red' }"
                  required
                  :readonly="blockEdit"
                  v-model="cpfCnpjMasked">
                <span class="input-group-append">
                  <i
                    class="input-group-text ik"
                    :class="{ 'ik-thumbs-down': !cpfCnpjValid, 'ik-thumbs-up': cpfCnpjValid }" />
                </span>
              </div>
            </div>
          </div>
          <div
            class="form-group row"
            v-if="blockEdit">
            <label
              for="company"
              class="col-sm-4 col-form-label">* Razão Social</label>
            <div class="col-sm-8">
              <input
                id="company"
                type="text"
                class="form-control"
                readonly="readonly"
                v-model="company">
            </div>
          </div>
          <div
            class="form-group row"
            v-if="blockEdit">
            <label
              for="addressZipCode"
              class="col-sm-4 col-form-label">* CEP</label>
            <div class="col-sm-8">
              <input
                id="addressZipCode"
                type="text"
                class="form-control"
                maxlength="8"
                readonly="readonly"
                v-model="addressZipCodeMasked">
            </div>
          </div>
          <div
            class="form-group row"
            v-if="blockEdit">
            <label
              for="address"
              class="col-sm-4 col-form-label">* Endereço</label>
            <div class="col-sm-4">
              <input
                id="address"
                type="text"
                class="form-control"
                maxlength="255"
                readonly="readonly"
                v-model="address">
            </div>
            <label
              for="addressNumber"
              class="col-sm-2 col-form-label">* Número</label>
            <div class="col-sm-2">
              <input
                id="addressNumber"
                type="number"
                class="form-control"
                maxlength="10"
                readonly="readonly"
                v-model="addressNumber">
            </div>
          </div>
          <div
            class="form-group row"
            v-if="blockEdit">
            <label
              for="addressComplement"
              class="col-sm-4 col-form-label">Complemento</label>
            <div class="col-sm-8">
              <input
                id="addressComplement"
                type="text"
                class="form-control"
                maxlength="255"
                readonly="readonly"
                v-model="addressComplement">
            </div>
          </div>
          <div
            class="form-group row"
            v-if="blockEdit">
            <label
              for="addressProvince"
              class="col-sm-4 col-form-label">* Bairro</label>
            <div class="col-sm-8">
              <input
                id="addressProvince"
                type="text"
                class="form-control"
                maxlength="255"
                readonly="readonly"
                v-model="addressProvince">
            </div>
          </div>
          <div
            class="form-group row"
            v-if="blockEdit">
            <label
              for="phone"
              class="col-sm-4 col-form-label">Telefone Fixo</label>
            <div class="col-sm-8">
              <input
                id="phone"
                type="text"
                class="form-control"
                v-model="phoneMasked">
            </div>
          </div>
          <div
            class="form-group row"
            v-if="blockEdit">
            <label
              for="mobilePhone"
              class="col-sm-4 col-form-label">Telefone Celular</label>
            <div class="col-sm-8">
              <input
                id="mobilePhone"
                type="text"
                class="form-control"
                v-model="mobilePhoneMasked">
            </div>
          </div>
          <div
            class="form-group row"
            v-if="blockEdit">
            <label
              for="additionalEmails"
              class="col-sm-4 col-form-label"
              title="Insira até 5 emails separados por vírgula"
              data-toggle="tooltip"
              data-placement="top">Emails para notificações</label>
            <div class="col-sm-8">
              <input
                id="additionalEmails"
                type="text"
                class="form-control"
                v-model="additionalEmails">
            </div>
          </div>
          <div class="buttons flex">
            <button
              class="btn btn-outline-secondary"
              v-if="showReturnTo"
              @click.prevent="onCancel">
              Voltar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              @click.prevent="onSubmit">
              {{ blockEdit ? 'Atualizar' : 'Validar' }}
            </button>
          </div>
        </form>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="financialDataSuccess"
      ref="financialDataSuccess"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5>Seus dados foram atualizados com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import {parsePhoneNumberFromString} from 'libphonenumber-js'
import { EventBus } from '@/services/event-bus'

export default {
  name: 'FinancialData',
  props: {
    returnTo: {
      type: String,
      default: 'organizationProfile'
    }
  },
  data () {
    return {
      errors: null,
      status: null,
      cpfCnpj: null,
      cpfCnpjLabel: '...',
      cpfCnpjValid: false,
      company: null,
      phone: null,
      mobilePhone: null,
      address: null,
      addressNumber: null,
      addressComplement: null,
      addressProvince: null,
      addressZipCode: null,
      additionalEmails: null
    }
  },
  mounted () {
    this.getFinancialData()
  },
  methods: {
    getFinancialData () {
      const financialData = this.$store.state.auth.financialData
      if (financialData) {
        this.assignFinancialDataToProperties(financialData)
      } else {
        this.errors = [{
          message: [
            'Seus dados financeiros não foram encontrados, ',
            '<a href="https://wa.me/+554833328503" target="_blank" class="link">clique aqui e fale com nosso suporte via WhatsApp!</a>.'
          ].join(''),
          key: 'error'
        }]
      }
    },
    onSubmit () {
      this.errors = null
      const form = this.$refs.financialDataForm
      if (form.checkValidity()) {
        if (this.status === 'PENDING') {
          const paramsToCreate = {
            cpfCnpj: this.cpfCnpj
          }
          loopback
            .post('/accounts/financial', paramsToCreate)
            .then(financialDataCreated => {
              if (financialDataCreated) {
                this.$store.commit('auth/setFinancialData', financialDataCreated)
                this.$store.dispatch('auth/loadSoftswitchIntegration')
                this.assignFinancialDataToProperties(financialDataCreated)
                EventBus.$emit('reload-balance')
                $(this.$refs.financialDataSuccess).modal('show')
              } else {
                this.errors = [{
                  message: [
                    'Não foi possível criar seus dados financeiros, ',
                    '<a href="https://wa.me/+554833328503" target="_blank" class="link">clique aqui e fale com nosso suporte via WhatsApp!</a>.'
                  ],
                  key: 'error'
                }]
              }
            })
            .catch(err => {
              if (err.message && err.message === 'cpfCnpj already in use') {
                this.errors = [{
                  message: [
                    'CPF/CNPJ já está em uso, ',
                    '<a href="https://wa.me/+554833328503" target="_blank" class="link">clique aqui e fale com nosso suporte via WhatsApp!</a>.'
                  ].join(''),
                  key: 'error'
                }]
              } else if (err.message && ['invalid cnpj', 'cpfCnpj: invalid'].includes(err.message)) {
                this.errors = [{
                  message: 'CPF/CNPJ inválido.',
                  key: 'error'
                }]
              } else if (err.message && err.message.includes('invalid cpf')) {
                this.errors = [{
                  message: [
                    'CPF inválido ou sem endereço válido cadastrado, ',
                    '<a href="https://wa.me/+554833328503" target="_blank" class="link">clique aqui e fale com nosso suporte via WhatsApp!</a>.'
                  ].join(''),
                  key: 'error'
                }]
              } else {
                this.errors = [{
                  message: err.message,
                  key: 'error'
                }]
              }
            })
        } else if (this.status === 'ACTIVE') {
          const paramsToUpdate = {
            phone: this.phone,
            mobilePhone: this.mobilePhone,
            additionalEmails: this.additionalEmails
          }
          loopback
            .put('/accounts/financial', paramsToUpdate)
            .then(financialDataUpdated => {
              if (financialDataUpdated) {
                this.$store.commit('auth/setFinancialData', financialDataUpdated)
                this.assignFinancialDataToProperties(financialDataUpdated)
                $(this.$refs.financialDataSuccess).modal('show')
              }
            })
            .catch(err => {
              if (err.message && err.message.includes('phone: invalid')) {
                this.errors = [{
                  message: 'Telefone Fixo inválido. Exemplo: (22) 3333-4444',
                  key: 'error'
                }]
              } else if (err.message && err.message.includes('mobilePhone: invalid')) {
                this.errors = [{
                  message: 'Telefone Celular inválido. Exemplo: (22) 99999-9999',
                  key: 'error'
                }]
              } else if (err.message && err.message.includes('additionalEmails: invalid')) {
                if (err.message.includes('maximum 5 emails')) {
                  this.errors = [{
                    message: 'Máximo de 5 emails adicionais.',
                    key: 'error'
                  }]
                } else {
                  this.errors = [{
                    message: 'Emails adicionais inválidos. Exemplo: "contato@dominio.com,financeiro@dominio.com"',
                    key: 'error'
                  }]
                }
              } else {
                this.errors = [{
                  message: err.message,
                  key: 'error'
                }]
              }
            })
        } else if (this.status === 'CANCELED') {
          this.errors = [{
            message: [
              'Sua conta está bloqueada, ',
              '<a href="https://wa.me/+554833328503" target="_blank" class="link">clique aqui e fale com nosso suporte via WhatsApp!</a>.'
            ].join(''),
            key: 'error'
          }]
        }
      } else {
        this.errors = [{
          message: 'Preencha o CPF/CNPJ corretamente.',
          key: 'error'
        }]
      }
    },
    onCancel () {
      this.$router.push({ name: this.returnTo })
    },
    assignFinancialDataToProperties (financial) {
      if (financial) {
        this.status = financial.status
        this.cpfCnpj = financial.cpfCnpj
        this.company = financial.company
        this.phone = financial.phone
        this.mobilePhone = financial.mobilePhone
        this.address = financial.address
        this.addressNumber = financial.addressNumber
        this.addressComplement = financial.addressComplement
        this.addressProvince = financial.addressProvince
        this.addressZipCode = financial.addressZipCode
        this.additionalEmails = financial.additionalEmails
      } else {
        this.errors = [{
          message: [
            'Seus dados financeiros não foram encontrados, ',
            '<a href="https://wa.me/+554833328503" target="_blank" class="link">clique aqui e fale com nosso suporte via WhatsApp!</a>.'
          ].join(''),
          key: 'error'
        }]
      }
    },
    cpfCnpjCheck () {
      this.cpfCnpj = String(this.cpfCnpj).replace(/[^0-9]/g, '')
      if (this.cpfCnpj.length === 11) {
        this.cpfCnpjLabel = 'CPF'
        this.cpfCnpjValid = true
      } else if (this.cpfCnpj.length === 14) {
        this.cpfCnpjLabel = 'CNPJ'
        this.cpfCnpjValid = true
      } else {
        this.cpfCnpjValid = false
        this.cpfCnpjLabel = '...'
      }
    }
  },
  computed: {
    blockEdit () {
      return this.status === 'ACTIVE' || !this.status
    },
    showReturnTo () {
      return ['automaticRecharge', 'chargeHistory'].includes(this.returnTo)
    },
    cpfCnpjMasked: {
      get () {
        if (this.cpfCnpjLabel === 'CPF') {
          return this.cpfCnpj
            ? this.cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
            : ''
        } else if (this.cpfCnpjLabel === 'CNPJ') {
          return this.cpfCnpj
            ? this.cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
            : ''
        } else {
          return this.cpfCnpj
        }
      },
      set (value) {
        this.cpfCnpj = value.replace(/[^0-9]/g, '')
      }
    },
    phoneMasked: {
      get () {
        const phoneParsed = parsePhoneNumberFromString(String(this.phone), 'BR')
        if (phoneParsed && phoneParsed.isValid()) return phoneParsed.formatNational()
        else return this.phone
      },
      set (value) {
        this.phone = value.replace(/[^0-9]/g, '')
      }
    },
    mobilePhoneMasked: {
      get () {
        const phoneParsed = parsePhoneNumberFromString(String(this.mobilePhone), 'BR')
        if (phoneParsed && phoneParsed.isValid()) return phoneParsed.formatNational()
        else return this.mobilePhone
      },
      set (value) {
        this.mobilePhone = value.replace(/[^0-9]/g, '')
      }
    },
    addressZipCodeMasked: {
      get () {
        return this.addressZipCode
          ? this.addressZipCode.replace(/(\d{5})(\d{3})/, '$1-$2')
          : ''
      },
      set (value) {
        this.addressZipCode = value.replace(/[^0-9]/g, '')
      }
    }
  },
  watch: {
    cpfCnpj: {
      handler: function cpfCnpjObserver () {
        this.errors = null
        this.cpfCnpjCheck()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-tabs {
  margin-bottom: 20px;
}
.copy-url-piperun {
  font-weight: bold;
}
.embed-responsive {
  max-width: 800px;
  max-height: 600px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Organization/FinancialData.vue